import decode from "jwt-decode";
import Voip from "src/utils/singleton/voip";

export const AUTH_SET_TOKEN = "AUTH_SET_TOKEN";
export const AUTH_SUCCESS = "AUTH_SUCCESS";

export const SET_REDIRECT_TO_REFERRER = "SET_REDIRECT_TO_REFERRER";
export const setRedirectToReferrer = url => ({
    type: SET_REDIRECT_TO_REFERRER,
    payload: url
});

export const authenticate = (email, password) => (dispatch, getState, api) =>
    api.post("/auth/login", { email, password }).then(({ data }) => {
        const user = {
            ...data,
            ...decode(data.token).data,
            isOperator: false
        };
        console.log("HERE:", data.token);
        dispatch({ type: AUTH_SET_TOKEN, payload: data });
        dispatch({
            type: AUTH_SUCCESS,
            payload: user
        });
    });

export const authenticateOperator = (username, password) => (
    dispatch,
    getState,
    api
) =>
    api
        .post("/auth/operator-login", { username, password })
        .then(({ data }) => {
            const user = {
                ...data,
                ...decode(data.token).data,
                isOperator: true
            };

            if (user.team.voip) {
                try {
                    Voip.connect(user);
                } catch (error) {
                    console.log(error);
                }
            }

            dispatch({ type: AUTH_SET_TOKEN, payload: data });
            dispatch({
                type: AUTH_SUCCESS,
                payload: user
            });
        });

export const REGISTERED_USER = "REGISTERED_USER";
export const register = (name, email, password, phone) => (
    dispatch,
    getState,
    api
) =>
    api
        .post("/users", {
            name,
            email,
            password,
            phone,
            utmSource: localStorage.getItem("utm_source"),
            utmMedium: localStorage.getItem("utm_medium"),
            utmCampaign: localStorage.getItem("utm_campaign"),
            isCorp: true
        })
        .then(() => dispatch({ type: REGISTERED_USER, payload: {} }));

export const NEW_PASSWORD_SUCCESS = "NEW_PASSWORD_SUCCESS";
export const forgotPassword = email => (dispatch, getState, api) =>
    api
        .post("/users/forgot-password", { email })
        .then(() => dispatch({ type: NEW_PASSWORD_SUCCESS }));

export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const resetPassword = (password, token) => (dispatch, getState, api) =>
    api.post("/users/reset-password", { password, token }).then(res =>
        authenticate(res.data.email, password)(dispatch, getState, api).then(
            () =>
                dispatch({
                    type: RESET_PASSWORD_SUCCESS,
                    payload: { email: res.data.email, password }
                })
        )
    );

export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const logout = () => dispatch =>
    dispatch({
        type: AUTH_LOGOUT,
        payload: true
    });
